import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GatewayService {
  private readonly http: HttpClient = inject(HttpClient);

  getSyncGateways(merchantId: string){
    return this.http.get<any>(`/develop/v1/sync/merchants/${merchantId}/gateways`);
  }

  updateSyncGateways(data: any, merchantId: string){
    return this.http.put(`/develop/v1/sync/merchants/${merchantId}/gateways`, data);
  }

  getGateways(id){
    return this.http.get<any>(`/develop/v1/gateways?merchant=${id}&type=IGFS`);
  }

  getGateway(id){
    return this.http.get<any>('/develop/v1/gateways/' + id);
  }

  updateGateways(data: any, id: string){
    return this.http.put('/develop/v1/gateways/' + id, data);
  }

  creategateway(data: any) {
    return this.http.post('/develop/v1/gateways/', data);
  }

}
